import { ReactNode } from "react";

interface PageHeaderProps {
    /** Small uppercase label above the title — usually the navigation group. */
    eyebrow?: ReactNode;
    title: ReactNode;
    /** Record count, rendered as a pill beside the title. */
    count?: number;
    subtitle?: ReactNode;
    /** Buttons aligned to the trailing edge. */
    actions?: ReactNode;
}

/**
 * The opening block of every screen, replacing the old `<h4>` + `<Divider/>`.
 *
 * The count deliberately lives *outside* the heading element: an admin should
 * see it, but it must not end up in the heading's accessible name.
 */
export const PageHeader = ({ eyebrow, title, count, subtitle, actions }: PageHeaderProps) => (
    <div className="page-header">
        <div className="page-header__text">
            {eyebrow != null ? <span className="page-header__eyebrow eyebrow">{eyebrow}</span> : null}
            <div className="page-header__title">
                <h1 className="page-header__heading">{title}</h1>
                {count != null ? <span className="page-header__count">{count}</span> : null}
            </div>
            {subtitle != null ? <p className="page-header__subtitle">{subtitle}</p> : null}
        </div>
        {actions != null ? <div className="page-header__actions">{actions}</div> : null}
    </div>
);
